<script setup lang="ts">
import { computed, ref, useId, watch } from 'vue';

const generatedId = useId();

const props = withDefaults(defineProps<{ isChecked: boolean; inputId?: string; isIndeterminate?: boolean; size?: number }>(), {
  inputId: undefined,
  size: 16,
});
const emits = defineEmits<{ (e: 'change', isChecked: boolean): void }>();

const inputRef = ref<HTMLInputElement | null>(null);
const isChecked = ref<boolean>(false);

const sizePx = computed(() => `${props.size}px`);
const inputId = computed(() => props.inputId ?? generatedId);

watch(
  () => props.isChecked,
  (newValue) => {
    isChecked.value = newValue;
  },
  { immediate: true }
);

watch(
  [() => props.isIndeterminate, inputRef],
  ([newValue, input]) => {
    if (input) input.indeterminate = !!newValue;
  },
  { immediate: true }
);
</script>
<template>
  <input :id="inputId" ref="inputRef" v-model="isChecked" type="checkbox" @change="emits('change', isChecked)" />
</template>
<style lang="scss" scoped>
input {
  width: v-bind(sizePx);
  height: v-bind(sizePx);
  border-radius: 1px;
  border-color: $gray30;
  vertical-align: middle;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
</style>
